export const WHEN_TO_USE = `Open one of the view's configuration side panels for
the user to work in — view options (choose the view and its settings), grouping,
label formatting, or conditional formatting — or close the side panel. This only
navigates the UI; it changes nothing.

Call it ONLY when
- the user explicitly asks to open that UI to edit or inspect one of these
  manually (e.g. "let me set the grouping myself", "open conditional formatting",
  "show me the formatting rules")
- when the user's request is too complex for you to carry out directly, you may
  OFFER to open the relevant panel so the user can inspect or modify the created
  rules themselves — and open it only after they accept.`;

export const VIEW_SIDE_PANEL_NAV_CONTEXT_DESCRIPTION = `'currentPanel' — the id of the view
side panel currently open, or null when the side panel is closed. Do not emit a
'panel' that already matches this state (the same id, or null when it is already
closed).`;
